import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const EMPTY = { loading: false, verified: false, has_credits: false, number: null };

// Fetches the paid call-in number; the backend reveals it only when the phone
// is verified AND the user holds credits. Returns { loading, verified, has_credits, number }.
export const usePaidLine = () => {
  const [state, setState] = useState({ ...EMPTY, loading: true });

  useEffect(() => {
    let alive = true;
    api
      .get("/paid-line")
      .then(({ data }) => {
        if (alive) setState({ loading: false, ...data });
      })
      .catch(() => {
        if (alive) setState(EMPTY);
      });
    return () => {
      alive = false;
    };
  }, []);

  return state;
};
